import { render, staticRenderFns } from "./ListadoSiniestros.vue?vue&type=template&id=6f8edec0&"
import script from "./ListadoSiniestros.vue?vue&type=script&lang=js&"
export * from "./ListadoSiniestros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports